export default __webpack_public_path__ + "images/7_2_image.jpg";